import { lazy } from 'react'
import withSuspense from '../../shared/hoc/withSuspense'

const AppInitController = lazy(() => import('./AppInit.controller'))

export default withSuspense(AppInitController, { progress: 25 })
